import React, { Component } from 'react';
import LayoutBackoffice from '../../header_footer/LayoutBackoffice';
import FormRestaurante from './FormRestaurante';

import axios from "axios";
import PropTypes from "prop-types";

class EditRestaurante extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
      };
    constructor(props) {
        super(props);
        this.state = {
            restaurante: {}
          };
    }

    componentDidMount() {
        this.loadRestaurante();
    }

    loadRestaurante = async () => {
        let identifier = this.props.match.params.identifier;
    
        let res = {};
        try {
          res = await axios.get("/api/restaurantes/" + identifier, {
            headers: {
              APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf"
            }
          });
        } catch (error) {
          console.log(error);
        }
    
        let restaurante = res.data.restaurante;
        this.setState({ restaurante });
      };



    render() {
        return (
            <LayoutBackoffice>
                <div className="container">
                    <h2 className="backoffice-titulo-pagina">Editar restaurante</h2>
                    <FormRestaurante mode="Editar" data={this.state.restaurante}></FormRestaurante>
                </div>
            </LayoutBackoffice>
        );
    }
}

EditRestaurante.propTypes = {

};

export default EditRestaurante;